import React from 'react';
import PropTypes from 'prop-types';

const getBarColor = value => {
  if (value < 0) {
    return '#FF0000';
  } else if (value === 100) {
    return '#50B033';
  } else if (value === 50) {
    return '#556633';
  } else if (value === 0) {
    return '#B2C4DC';
  }
  return '';
};

const DataHaulGridProgressBar = props => (
  <div className="progress">
    <div
      className="progress-bar"
      role="progressbar"
      aria-valuenow={100}
      aria-valuemin="0"
      aria-valuemax="100"
      style={{
        width: '100%',
        backgroundColor: `${getBarColor(props.value)}`,
      }}
    />
  </div>
);

DataHaulGridProgressBar.propTypes = {
  value: PropTypes.number.isRequired,
};

export default DataHaulGridProgressBar;
